/**
 * SubjectManagementLayout
 * Layout wrapper for subject management section with sidebar navigation
 */

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser, selectCurrentProject } from '../../store/slices/user';
import { MainNavigation } from '../../components/main-navigation/main-navigation';
import { Sidebar } from '../../components/sidebar/sidebar';
import { MainLayoutV2 } from '../../components/main-layout-v2/main-layout-v2';
import UnifiedAiButton from '../../components/UnifiedAiButton/UnifiedAiButton';

const SubjectManagementLayout = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const currentUser = useSelector(selectUser);
  const currentProject = useSelector(selectCurrentProject);

  const isAiAssistantRoute = pathname.includes('/ai-assistant');
  const isSubjectDetailsRoute = pathname.includes('/subject-management/subject/');

  // For subject details page we return only Outlet,
  // because SubjectLayout already has its own MainLayoutV2 + Sidebar
  if (isSubjectDetailsRoute) {
    return <Outlet />;
  }

  const leftSideNavItems = [
    { key: '/subject-management', label: 'Subjects', default: true },
    { key: '/subject-management/pending', label: 'Pending subjects' },
    { key: '/subject-management/disabled', label: 'Blocked subjects' },
    { key: '/subject-management/uploads', label: 'Uploads' },
    { key: '/subject-management/ai-assistant', label: 'LifeFit360 AI ✨' }
  ];

  return (
    <MainLayoutV2>
      <MainNavigation />

      {!isAiAssistantRoute && (
        <Sidebar
          items={leftSideNavItems}
          title={t('subject_management.title')}
        />
      )}

      <Outlet />

      {!isAiAssistantRoute &&
        currentUser &&
        currentUser.id &&
        currentProject &&
        currentProject.id && (
          <UnifiedAiButton
            userId={currentUser.id}
            currentRoute={pathname}
            projectId={currentProject.id}
            contextData={null}
          />
        )}
    </MainLayoutV2>
  );
};

export default SubjectManagementLayout;